import { render, staticRenderFns } from "./InspirationPage.vue?vue&type=template&id=8e7d93c4&"
import script from "./InspirationPage.vue?vue&type=script&lang=js&"
export * from "./InspirationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports